// extracted by mini-css-extract-plugin
module.exports = {"price":"Price_price__0XuFe","originalPrice":"Price_originalPrice__A_W9w","priceWrapper":"Price_priceWrapper__FJUeh","discountedPrice":"Price_discountedPrice__z_giB"};